module.exports = __webpack_public_path__ + "media/hallBgm.cf4decdf.mp3";